export default function Home(){

    window.location.href = '/app/';

    return <></>
}
